import { IJumpToBottom } from './jump_to_bottom';

export interface IContentWrapper {
    setJumpToBottom(jumpToBottom: IJumpToBottom): void;
    open(): void;
    close(): void;
}

export class ContentWrapper implements IContentWrapper {
    jumpToBottom: IJumpToBottom;
    isOpen = false;

    handleScroll() {
        this.jumpToBottom.setVisibility();
    }

    open() {
        this.isOpen = true;
        this.jumpToBottom.setVisibility();
    }

    close() {
        this.isOpen = false;
    }

    setJumpToBottom(jumpToBottom: IJumpToBottom) {
        this.jumpToBottom = jumpToBottom;
    }
}
